import React from 'react';
import { makeStyles } from '@material-ui/styles';
import ProductionReport from './components/ProductionReport';
import { useTranslation } from 'react-i18next';
import { Page, PageHeader } from 'components';
import { useSensors } from 'hooks';
import { useEffect } from 'react';
import { Card } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: '100%',
    height: '100%',
    minHeight: '100%',
    flex: 1,
  },
  header: {
    marginBottom: theme.spacing(2),
  },
}));

const ProductionPage = () => {
  const classes = useStyles();
  const pageProps = {};
  const { t } = useTranslation();
  const { fetchSensors } = useSensors();

  useEffect(() => {
    fetchSensors();
  }, []);

  return (
    <Page title={t('production')} className={classes.root}>
      <PageHeader title={t('production')} {...pageProps} className={classes.header} />
      <Card>
        <ProductionReport />
      </Card>
    </Page>
  );
};

export default ProductionPage;
